import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Stack, Loader, Text, Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useCompleteOAuth } from '@/hooks/useGoogleAds';

export function GoogleAdsOAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const completeOAuth = useCompleteOAuth();

  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const error = searchParams.get('error');

  useEffect(() => {
    if (error) {
      return;
    }

    if (code && state) {
      completeOAuth.mutate(
        { code, state },
        {
          onSuccess: () => {
            navigate('/google-ads-auditor', { replace: true });
          },
          onError: () => {
            // Error is displayed below
          },
        },
      );
    }
  }, [code, state, error]);

  if (error) {
    return (
      <Container size="sm" py="xl">
        <Alert icon={<IconAlertCircle size={16} />} title="Authentifizierung fehlgeschlagen" color="red">
          <Text size="sm">
            {error === 'access_denied'
              ? 'Sie haben den Zugriff auf Ihr Google Ads Konto verweigert.'
              : `Fehler bei der Authentifizierung: ${error}`}
          </Text>
          <Text
            size="sm"
            c="blue"
            style={{ cursor: 'pointer', marginTop: 8 }}
            onClick={() => navigate('/google-ads-auditor')}
          >
            Zurück zum Google Ads Auditor
          </Text>
        </Alert>
      </Container>
    );
  }

  if (completeOAuth.isError) {
    return (
      <Container size="sm" py="xl">
        <Alert icon={<IconAlertCircle size={16} />} title="Verbindung fehlgeschlagen" color="red">
          <Text size="sm">
            Die Verbindung zu Google Ads konnte nicht hergestellt werden. Bitte versuchen Sie es erneut.
          </Text>
          <Text
            size="sm"
            c="blue"
            style={{ cursor: 'pointer', marginTop: 8 }}
            onClick={() => navigate('/google-ads-auditor')}
          >
            Zurück zum Google Ads Auditor
          </Text>
        </Alert>
      </Container>
    );
  }

  return (
    <Container size="sm" py="xl">
      <Stack align="center" gap="md">
        <Loader size="lg" />
        <Text>Verbindung wird hergestellt...</Text>
      </Stack>
    </Container>
  );
}
